<div class="login__container">
  <div class="form__wrapper">
    <form class="login__form" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
      <img alt="menu logo" src="{{ LOGO }}" class="img__logo" />
      <h3 class="main-title left-aligned">Prijava</h3>
      <h3 class="main-title main-subtitle left-aligned">Korisnički MaxBet nalog</h3>
      <div class="form-group" id="login_email">
        <div class="input-group">
          <div
            class="input-group-prepend"
            [ngClass]="{
              'is-invalid-icon': getLoginForm.email.errors && getLoginForm.email.touched,
              'is-valid-icon': getLoginForm.email.valid && getLoginForm.email.touched,
              'input-focus': isEmailInputFocused && !getLoginForm.email.touched
            }"
          >
            <img src="{{ USERNAME }}" alt="" />
          </div>
          <input
            type="email"
            class="form-control"
            formControlName="email"
            [class.is-valid]="getLoginForm.email.valid && getLoginForm.email.touched"
            [class.is-invalid]="
              getLoginForm.email.invalid && (getLoginForm.email.touched || getLoginForm.email.dirty)
            "
            placeholder="E-mail adresa"
            (input)="inputChanged($event)"
            [readOnly]="spinnerService.spinnerVisible"
            (focus)="isEmailInputFocused = true"
            (blur)="isEmailInputFocused = false"
          />
        </div>
        @if (getLoginForm.email.errors && !loginError && getLoginForm.email.touched) {
          <div class="invalid-feedback">
            @if (getLoginForm.email.errors.required) {
              <div>E-mail je obavezan!</div>
            } @else if (getLoginForm.email.errors.email || getLoginForm.email.invalid) {
              <div>Unos nije validan!</div>
            }
          </div>
        }
      </div>
      <div class="form-group passwod-group" id="login_password">
        <div class="input-group">
          <div
            class="input-group-prepend"
            [ngClass]="{
              'is-invalid-icon': getLoginForm.password.errors && getLoginForm.password.touched,
              'is-valid-icon': getLoginForm.password.valid && getLoginForm.password.touched,
              'input-focus': isPasswordInputFocused && !getLoginForm.password.touched
            }"
          >
            <img src="{{ PASSWORD }}" alt="" />
          </div>
          <input
            type="password"
            class="form-control"
            formControlName="password"
            [class.is-valid]="getLoginForm.password.valid && getLoginForm.password.touched"
            [class.is-invalid]="getLoginForm.password.invalid && getLoginForm.password.touched"
            placeholder="Lozinka"
            (input)="inputChanged($event)"
            autocomplete="on"
            [readOnly]="spinnerService.spinnerVisible"
            (focus)="isPasswordInputFocused = true"
            (blur)="isPasswordInputFocused = false"
          />
        </div>
        @if (getLoginForm.password.errors && !loginError && getLoginForm.password.touched) {
          <div class="invalid-feedback">
            @if (getLoginForm.password.errors.required) {
              <div>Lozinka je obavezna!</div>
            }
          </div>
        }
      </div>
      <div class="text-danger invalid-credentials__message">
        {{ loginError }}
      </div>
      <div class="checkbox__wrapper">
        <input
          type="checkbox"
          name="checkbox"
          id=""
          class="checkbox-accept"
          formControlName="rememberMe"
        />
        <span>Zapamti me</span>
      </div>
      <button
        type="submit"
        cButton
        class="btn--orange login__button"
        [disabled]="!loginForm.valid || spinnerService.spinnerVisible"
      >
        Prijavi se
        <app-button-spinner></app-button-spinner>
      </button>
      <div class="form__lower">
        <a routerLink="/{{ REGISTER_ROUTE }}" class="register">Registruj se</a>
      </div>
      <div class="divider">&nbsp;</div>
      <div class="bottom__links">
        <a routerLink="/{{ PASSWORD_RECOVERY_ROUTE }}" class="login__forget"
          >Zaboravljena lozinka?</a
        >
        <a routerLink="/{{ ABOUT_APP }}" class="login__about-app">O aplikaciji</a>
      </div>
      <div class="divider">&nbsp;</div>
    </form>
  </div>
</div>
